var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 11.0004C11.0153 10.7372 11.0153 10.3124 10.7586 10.0491L6.9347 6.12761L11.0075 1.9509C11.2642 1.68763 11.2642 1.26283 11.0075 0.999563C10.748 0.733478 10.3252 0.73348 10.0657 0.999564L6 5.16906L1.93427 0.999564C1.67481 0.733479 1.252 0.733478 0.992536 0.999563C0.735821 1.26283 0.735822 1.68763 0.992536 1.9509L5.0653 6.12761L1.2414 10.0491C0.984688 10.3124 0.984688 10.7372 1.2414 11.0004C1.50087 11.2665 1.92368 11.2665 2.18314 11.0004L6 7.08616L9.81686 11.0004C10.0763 11.2665 10.4991 11.2665 10.7586 11.0004Z",
    fill: "#2C3D50",
    stroke: "#2C3D50",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseMini);
export default __webpack_public_path__ + "static/media/icon-close-mini.e94b826c423203dbfd2b56fa138c7b8b.svg";
export { ForwardRef as ReactComponent };